import * as C from "io-ts/Codec";

export const FeatureFlagsModel = C.array(C.string);
